/** Shared row preview label for breakout wizard + accordion (avoid duplicated field walks). */

export function isReadableConnectionPreviewValue(value: unknown): value is string {
  if (typeof value !== 'string') return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  return !/^[A-Z0-9_-]{16,}$/i.test(trimmed);
}

export interface ReadableConnectionRowLabelOptions {
  /** When no readable text is found */
  fallback?: string;
}

export function getReadableConnectionRowLabel(
  row: any,
  source: any,
  options?: ReadableConnectionRowLabelOptions,
): string {
  const fallback = options?.fallback ?? '';
  if (!row || !source) return fallback;

  const fieldIds: string[] = source.data?.fieldIds ?? [];
  const attachmentFieldId = source.data?.attachmentFieldId;

  for (const fieldId of fieldIds) {
    if (fieldId === attachmentFieldId) continue;
    const value = row.getValue?.(fieldId) ?? row.getFieldValues?.()?.[fieldId];
    if (isReadableConnectionPreviewValue(value)) {
      return value.trim();
    }
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }

  if (row.data?.image?.originalFilename) {
    const name = row.data.image.originalFilename as string;
    const dotIdx = name.lastIndexOf('.');
    return dotIdx > 0 ? name.slice(0, dotIdx) : name;
  }

  const allValues = Object.values(row.getFieldValues?.() ?? {});
  for (const value of allValues) {
    if (isReadableConnectionPreviewValue(value)) {
      return value.trim();
    }
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }

  return fallback;
}
